import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfirmProvider } from "./contexts/ConfirmContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Courses from "./pages/Courses";
import Structure from "./pages/Structure";
import Vision from "./pages/Vision";
import Presentation from "./pages/Presentation";
import Schedules from "./pages/Schedules";
import Internships from "./pages/Internships";
import Exams from "./pages/Exams";
import Placement from "./pages/Placement";
import About from "./pages/About";
import PrivateRoute from "./components/PrivateRoute";
import AdminLayout from "./components/AdminLayout";
import System from "./pages/System";
import Home from "./pages/Home";
import NewCourse from "./pages/NewCourse";

function App() {
  return (
    <ConfirmProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="courses" element={<Courses />} />
          <Route path="courses/newcourse" element={<NewCourse />} />
          <Route path="courses/:id/edit" element={<NewCourse />} />
          <Route path="users" element={<Users />} />
          <Route path="system" element={<System />} />
          <Route path="structure" element={<Structure />} />
          <Route path="vision" element={<Vision />} />
          <Route path="presentation" element={<Presentation />} />
          <Route path="schedules" element={<Schedules />} />
          <Route path="internships" element={<Internships />} />
          <Route path="exams" element={<Exams />} />
          <Route path="placement" element={<Placement />} />
          <Route path="about" element={<About />} />
          <Route path="home" element={<Home />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfirmProvider>
  );
}

export default App;
